import _classCallCheck from "/vercel/path0/node_modules/.pnpm/@babel+runtime@7.15.4/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/vercel/path0/node_modules/.pnpm/@babel+runtime@7.15.4/node_modules/@babel/runtime/helpers/esm/createClass";
import _inherits from "/vercel/path0/node_modules/.pnpm/@babel+runtime@7.15.4/node_modules/@babel/runtime/helpers/esm/inherits";
import _possibleConstructorReturn from "/vercel/path0/node_modules/.pnpm/@babel+runtime@7.15.4/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "/vercel/path0/node_modules/.pnpm/@babel+runtime@7.15.4/node_modules/@babel/runtime/helpers/esm/getPrototypeOf";

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

import { Guard, Result, ValueObject } from '@digibricks/core';
export var ConfirmationResponse = /*#__PURE__*/function (_ValueObject) {
  _inherits(ConfirmationResponse, _ValueObject);

  var _super = _createSuper(ConfirmationResponse);

  function ConfirmationResponse() {
    _classCallCheck(this, ConfirmationResponse);

    return _super.apply(this, arguments);
  }

  _createClass(ConfirmationResponse, [{
    key: "clientId",
    get: function get() {
      return this.props.clientId;
    }
  }, {
    key: "accessId",
    get: function get() {
      return this.props.accessId;
    }
  }], [{
    key: "create",
    value: function create(props) {
      var guardCollections = [{
        argument: props.clientId,
        argumentName: 'Client Id'
      }, {
        argument: props.accessId,
        argumentName: 'Access Id'
      }];
      var guardResult = Guard.againstNullOrUndefinedBulk(guardCollections);

      if (!guardResult.succeeded) {
        var _guardResult$message;

        return Result.fail((_guardResult$message = guardResult.message) !== null && _guardResult$message !== void 0 ? _guardResult$message : 'Error');
      }

      return Result.ok(new ConfirmationResponse(props));
    }
  }]);

  return ConfirmationResponse;
}(ValueObject);